export default {
  VERIFY_EMAIL_SUCCESS: "Your email has been verified.",
  VERIFY_EMAIL_SUCCESS_EVENT: "VERIFY_EMAIL_SUCCESS_EVENT",
  VERIFY_EMAIL_EXPIRED: "Verification link has expired",
  VERIFY_EMAIL_EXPIRED_EVENT: "VERIFY_EMAIL_EXPIRED_EVENT",
  VERIFY_EMAIL_INVALID_EVENT: "VERIFY_EMAIL_INVALID_EVENT",
  VERIFY_EMAIL_ERROR: "This verification link is invalid.",
  VERIFY_EMAIL_STRIPE_ERROR: "Your card was declined. Please update your payment method.",
  RESEND_VERIFICATION_SUCCESS: "Verification email sent. Check your inbox.",
  RESEND_VERIFICATION_SUCCESS_EVENT: "RESEND_VERIFICATION_SUCCESS_EVENT",
  RESEND_VERIFICATION_ALREADY_VERIFIED: "Email already verified",
  RESEND_VERIFICATION_ALREADY_VERIFIED_EVENT: "RESEND_VERIFICATION_ALREADY_VERIFIED_EVENT",
  RESEND_VERIFICATION_ERROR_EVENT: "RESEND_VERIFICATION_ERROR_EVENT",
};
